import service from '@/store/services/settings/holidays-service';

const state = {
    list: {},
    holiday: {},
    meta: {},
    url:null
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, holiday) => {
        state.holiday = holiday;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    }
};

const actions = {
    list ({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(holiday => {
                commit('SET_RESOURCE', holiday);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(holiday => {
                commit('SET_RESOURCE', holiday);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((holiday) => {
                commit('SET_RESOURCE', holiday);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((holiday) => {
                commit('SET_RESOURCE', holiday);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};
const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    holiday: state => state.holiday,
    url: state => state.url,
};

const holidays = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default holidays;
